import * as React from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SvgRatingHalf = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 44,
  height: 44,
  viewBox: "0 0 22 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.68.668A.75.75 0 0 0 11 .25a.75.75 0 0 0-.679.418l-2.911 5.9L.9 7.51a.75.75 0 0 0-.415 1.28l4.717 4.591-1.112 6.484a.75.75 0 0 0 1.088.791L11 17.596l5.823 3.061a.75.75 0 0 0 1.088-.79L16.8 13.381l4.717-4.591a.75.75 0 0 0-.415-1.28l-6.51-.944L11.681.668Zm-.684 2.023L11 2.68l2.42 4.904a.75.75 0 0 0 .565.41l5.394.782-3.91 3.806a.75.75 0 0 0-.215.664l.922 5.375-4.827-2.538a.747.747 0 0 0-.354-.086V2.691Z",
  fill: "currentColor"
})));

export { SvgRatingHalf as default };
